import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersBelongingEmployeesPrivateQuestionAnswersIndexRequestType,
  ApiManagersBelongingEmployeesPrivateQuestionAnswersIndexResponseType,
} from "~/domains";

type RequestDataType = {
  params?: ApiManagersBelongingEmployeesPrivateQuestionAnswersIndexRequestType;
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ApiManagersBelongingEmployeesPrivateQuestionAnswersIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersBelongingEmployeesPrivateQuestionAnswersIndexResponseType>(
      "/api/managers/belonging_employees/private_question_answers",
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiManagersBelongingEmployeesPrivateQuestionAnswersIndexRequestType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisManagersBelongingEmployeesPrivateQuestionAnswersIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiManagersBelongingEmployeesPrivateQuestionAnswersIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisManagersBelongingEmployeesPrivateQuestionAnswersIndex", params],
    ({ pageParam }) => {
      return request({ params, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
